import ErrorPageIllutration from '@/assets/illustrations/error-page.svg';

const ErrorPage = () => {
  return (
    <div className="min-[95vh] flex w-full flex-col items-center justify-center">
      <img src={ErrorPageIllutration} alt="Error Page" />
      <div className="flex flex-col gap-2">
        <h5 className="text-text-primary text-center text-xl font-semibold">
          Oops! Something`s Not Right
        </h5>
        <p className="text-text-secondary text-center text-sm">
          We`re sorry it looks like there was an error. Please try again later.
        </p>
      </div>
    </div>
  );
};

export default ErrorPage;
